import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IGetFormaPagtoFilter} from "@components/formaPagamento/models/GetFormaPagtoFilter.ts";
import {IFormaPagamento, IFormaPagamentoForm} from "@models/formaPagamento/IFormaPagamento.ts";

export const __formapagto_endpoints = {
    ['v2']: {
        ['get-formas-pagto']: (data: IDataDto<IGetFormaPagtoFilter>): IApiEndpoint<IFormaPagamento[]> => {
            return {
                url: '/api/v2/formasPagamento',
                method: "GET",
                data: data,
            }
        },
        ['get-forma-pagto']: (data: IDataNoPageDto<{ formaPagtoId: number }>): IApiEndpoint<IFormaPagamento> => {
            return {
                url: `/api/v2/formasPagamento/${data.id}`,
                method: "GET",
                data: {...data, data: {}},
            }
        },
        ['forms']: {
            ['get-forms']: (data: IDataDto<{ formaPagtoId: number }>): IApiEndpoint<IFormaPagamentoForm[]> => {
                const {formaPagtoId, ...rest} = data.data
                return {
                    url: `/api/v2/formasPagamento/${formaPagtoId}/forms`,
                    data: {...data, data: {}},
                    method: "GET",
                }
            },
            ['create-forms']: (data: IDataNoPageDto<{
                formaPagtoId: number,
                forms: { nome: string, descricao?: string }[]
            }>): IApiEndpoint<IFormaPagamentoForm[]> => {
                const {formaPagtoId, ...rest} = data.data

                return ({
                    url: `/api/v2/FormasPagamento/${formaPagtoId}/forms`,
                    method: 'POST',
                    data: {...data, data: rest}
                })
            }
        }
    },
}